
import React from 'react';
import { agruparPorMes, agruparPorMesConsumos } from '../utils/ReportePDF';

const formatoMoneda = (valor) =>
    new Intl.NumberFormat("es-EC", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
      .format(Number(valor ?? 0));
  
const ReporteTable = ({ data, type, extraData }) => {
    if (!data) return null;

    // Tabla de Medidores
    if (type === 'medidores') {
        return (
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            {['#', 'Código', 'Ubicación', 'F. Instalación', 'Nombre', 'Estado', 'Cliente', 'Tarifa'].map(h => (
                                <th key={h} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {data.map((medidor, index) => (
                            <tr key={medidor.id_medidor}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{medidor.codigo_medidor}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{medidor.ubicacion_medidor}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{medidor.fecha_instalacion}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{medidor.nombre_medidor}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{medidor.estado_medidor}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{medidor.cliente?.nombre_cliente}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{medidor.tarifa?.tipo_tarifa}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    // Tabla de Clientes
    if (type === 'clientes') {
        return (
            <div className="overflow-x-auto">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            {['#', 'Nombre', 'Cédula', 'Dirección', 'Teléfono', 'Email', 'F. Registro'].map(h => (
                                <th key={h} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {data.map((cliente, index) => (
                            <tr key={cliente.id_cliente}>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{cliente.nombre_cliente}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{cliente.codigo_cliente}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{cliente.direccion_cliente}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{cliente.telefono_cliente}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{cliente.email_cliente}</td>
                                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{cliente.fecha_registro}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        );
    }

    // Tabla de Suma Total (Consumos Mensuales)
    if (type === 'suma-total') {
        if (!data.pagos?.length) return <div className="p-4 text-center text-gray-500">No hay pagos registrados para esta fecha.</div>;

        return (
            <div className="space-y-4">
                <div className="bg-blue-50 p-4 rounded-lg flex flex-wrap gap-4 text-sm text-blue-800">
                    <div><strong>Fecha de cobro:</strong> {extraData.selectedDate}</div>
                    <div><strong>Total Consumo:</strong> {data.totalConsumo} m³</div>
                    <div><strong>Total Exceso:</strong> {data.totalExceso} m³</div>
                    <div><strong>Total Cobrado:</strong> ${data.total}</div>
                </div>

                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                {['#', 'Medidor', 'Cliente', 'Lect. Ant', 'Lect. Act', 'Consumo', 'Base ($)', 'Exceso ($)', 'Mora', 'Reconexión', 'Sub Agua', 'Deudas', 'Total'].map(h => (
                                    <th key={h} className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data.pagos.map((pago, index) => (
                                <tr key={pago.id_pago}>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">{pago.codigo_medidor || pago.medidor?.codigo_medidor || 'N/A'}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{pago.nombre_cliente}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">{pago.lectura_anterior}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">{pago.lectura_actual}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">{pago.consumos?.m3 || (pago.lectura_actual - pago.lectura_anterior)} m³</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">${Number(pago.valores?.base || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">${Number(pago.valores?.valorExceso || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-red-600 font-medium text-right">${Number(pago.valores?.mora || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500 text-right">${Number(pago.valores?.reconexion || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm font-bold text-gray-800 text-right">${Number(pago.valores?.subtotal || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm font-bold text-gray-700 text-right">${Number(pago.valores?.deuda_extra || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm font-bold text-blue-700 text-right">${Number(pago.total_pagar || 0).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    // Reporte Rango (Rendición)
    if (type === 'reporte-rango') {
        const { ingresos, egresos, deudas, consumos } = data;
        const { tipoReporte } = extraData;

        // Procesamiento de datos (similar a Reportes.jsx)
        const egresosData = tipoReporte === "mes" ? Object.values(agruparPorMes(egresos?.egresos || [], "Egreso")) : (egresos?.egresos || []);
        const ingresosData = tipoReporte === "mes" ? Object.values(agruparPorMes(ingresos?.ingresos || [], "Ingreso")) : (ingresos?.ingresos || []);
        const deudasData = tipoReporte === "mes" ? Object.values(agruparPorMes(deudas?.deudas || [], "Deuda")) : (deudas?.deudas || []);
        const consumosData = Object.values(agruparPorMesConsumos(consumos?.pagos || []));

        return (
            <div className="space-y-8">
                {/* Egresos */}
                <SectionTable 
                    title="Tabla 1 - Egresos / Gastos" 
                    columns={['#', 'Descripción', 'Cantidad', 'Precio Total']} 
                    data={egresosData} 
                    totalLabel="Total Egresos" 
                    totalValue={egresos?.valor_total} 
                />

                {/* Ingresos */}
                <SectionTable 
                    title="Tabla 2 - Ingresos Generales" 
                    columns={['#', 'Descripción', 'Cantidad', 'Precio Total']} 
                    data={ingresosData} 
                    totalLabel="Total Ingresos" 
                    totalValue={ingresos?.valor_total} 
                />

                {/* Deudas */}
                <SectionTable 
                    title="Tabla 3 - Deudas por cobrar" 
                    columns={['#', 'Descripción', 'Cantidad', 'Precio Total']} 
                    data={deudasData} 
                    totalLabel="Total Deudas" 
                    totalValue={deudas?.valor_total} 
                />

                {/* Consumos */}
                <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
                    <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
                        <h3 className="font-semibold text-gray-700">Tabla 4 - Ingresos de Consumos Mensuales</h3>
                    </div>
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                {['#', 'N. Clientes', 'Monto', 'Fecha Pago'].map(h => (
                                    <th key={h} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                             {consumosData.map((item, index) => (
                                <tr key={index}>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.nombre_cliente}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">${item.consumo_total?.toFixed(2)}</td>
                                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.fecha_pago}</td>
                                </tr>
                             ))}
                        </tbody>
                    </table>
                    <div className="bg-gray-50 px-6 py-3 text-right">
                        <span className="font-medium text-gray-700">Total Consumos: </span>
                        <span className="font-bold text-gray-900">${consumos?.valor_total?.toFixed(2)}</span>
                    </div>
                </div>

            </div>
        );
    }

    if (type === 'morosos') {
        if (!data?.length) return <div className="p-4 text-center text-gray-500">No hay clientes morosos o con deudas.</div>;

        const sumTotalAgua = data.reduce((acc, curr) => acc + (curr.subtotalAgua || 0), 0);
        const sumTotalExtras = data.reduce((acc, curr) => acc + (curr.totalDeudasExtra || 0), 0);
        const sumTotalDeuda = data.reduce((acc, curr) => acc + (curr.totalDeuda || 0), 0);

        return (
            <div className="space-y-4">
                <div className="bg-red-50 p-4 rounded-lg flex flex-wrap gap-4 text-sm text-red-800">
                    <div><strong>Total clientes deudores:</strong> {data.length}</div>
                    <div><strong>Total Agua:</strong> ${sumTotalAgua.toFixed(2)}</div>
                    <div><strong>Total Deudas Extras:</strong> ${sumTotalExtras.toFixed(2)}</div>
                    <div><strong>Deuda Total Estimada:</strong> ${sumTotalDeuda.toFixed(2)}</div>
                </div>

                <div className="overflow-x-auto">
                    <table className="min-w-full divide-y divide-gray-200">
                        <thead className="bg-gray-50">
                            <tr>
                                {['#', 'Medidor', 'Cliente', 'Meses deuda', 'Subtotal Agua', 'Deudas Extras', 'Total Deuda'].map(h => (
                                    <th key={h} className="px-3 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h}</th>
                                ))}
                            </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                            {data.map((mora, index) => (
                                <tr key={mora.medidorId || index}>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm font-medium text-gray-900">{mora.codigoMedidor || 'N/A'}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-900">{mora.cliente}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-red-600 font-bold text-center">{mora.mesesMora} meses</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-600 font-medium text-right">${Number(mora.subtotalAgua || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-gray-600 font-medium text-right">${Number(mora.totalDeudasExtra || 0).toFixed(2)}</td>
                                    <td className="px-3 py-4 whitespace-nowrap text-sm text-red-600 font-bold text-right">${Number(mora.totalDeuda || 0).toFixed(2)}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }

    return null;
};

const SectionTable = ({ title, columns, data, totalLabel, totalValue }) => (
    <div className="bg-white rounded-lg border border-gray-200 overflow-hidden">
        <div className="px-4 py-3 bg-gray-50 border-b border-gray-200 flex justify-between items-center">
            <h3 className="font-semibold text-gray-700">{title}</h3>
        </div>
        <div className="overflow-x-auto">
            <table className="min-w-full divide-y divide-gray-200">
                <thead className="bg-gray-50">
                    <tr>
                        {columns.map(h => (
                            <th key={h} className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">{h}</th>
                        ))}
                    </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-200">
                    {data.map((item, index) => (
                        <tr key={index}>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{index + 1}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{item.descripcion}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500">{item.cantidad}</td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">{formatoMoneda(item.precio_total)}</td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
        <div className="bg-gray-50 px-6 py-3 text-right">
            <span className="font-medium text-gray-700">{totalLabel}: </span>
            <span className="font-bold text-gray-900">{formatoMoneda(totalValue)}</span>
        </div>
    </div>
);

export default ReporteTable;
